import { MessagePartPrimitive } from '@assistant-ui/react';
import { faHourglass } from '@fortawesome/duotone-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import './Text.scss';

export const Text: FC = () => (
  <div className={'chat-text-message box'}>
    <div className={'content'}>
      <p>
        <MessagePartPrimitive.Text component={'span'} />
        <MessagePartPrimitive.InProgress>
          <span className={'icon'}>
            <FontAwesomeIcon icon={faHourglass} spin />
          </span>
        </MessagePartPrimitive.InProgress>
      </p>
    </div>
  </div>
);
Text.displayName = 'Text';
